import { useContext } from 'react';

import cookie from 'cookie';
import { useLocation } from 'react-router-dom';

import { AuthContext } from '@src/app/contexts/Auth';
import ModalLayout from '@src/ui/layouts/ModalLayout';
import CreateUserView from '@src/ui/views/auth/CreateUserView';

const headingText: Record<string, string> = {
    create_account:
        'Your quote is ready. Create an account to access it securely.',
    save_for_later: 'Save your progress',
};
const buttonText: Record<string, string> = {
    create_account: 'Get your quote',
    save_for_later: 'Create account',
};

interface CreateAccountModalProps {
    open: boolean;
    onClose: () => void;
}

export const CreateAccountModal = ({
    open,
    onClose,
}: CreateAccountModalProps) => {
    const { register } = useContext(AuthContext);
    const location = useLocation();

    const cookies = cookie.parse(document.cookie);
    const appInfo = cookies.application ? JSON.parse(cookies.application) : {};

    const flow =
        (location.state as { intent: string } | undefined)?.intent || 'default';

    const email = (
        new URLSearchParams(location.search).get('email') ||
        appInfo.emailAddress ||
        ''
    ).replace(/ /g, '+');

    return (
        <ModalLayout
            contentClassName='max-w-xl mx-auto'
            subContentClassName='xs:px-24'
            open={open}
            onClose={onClose}
            title={
                flow !== 'default' ? headingText[flow] : 'Save your progress'
            }
        >
            <CreateUserView
                register={register}
                email={email}
                buttonText={buttonText[flow]}
                onClose={onClose}
            />
        </ModalLayout>
    );
};
